import styled, { keyframes, css, createGlobalStyle } from 'styled-components';
import { motion } from 'framer-motion';
import React from 'react';

const motionBox = {
  initial: {
    height: '100vh'
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.8,
      ease: [0.87, 0, 0.13, 1]
    }
  }
};
const outer = keyframes`
  50% {
    transform: translateY(0);
  }
  25%,
  75% {
    transform: translateY(4px);
  }
`;
const body = keyframes`
  50% {
    transform: rotate(16deg);
  }
  25%,
  75% {
    transform: rotate(24deg);
  }
`;
const armLeg = keyframes`
  50% {
    transform: rotate(var(--r-to));
  }
`;
const armBefore = keyframes`
  30%,
  70% {
      transform: rotate(var(--r-to));
  }
`;
const GlobalStyle = createGlobalStyle`
  body {
    height: calc(100% - 40px);
  }
`;
const bodyPart = css`
  content: '';
  width: var(--w, 11px);
  height: 4px;
  top: var(--t, 0);
  left: var(--l, 2px);
  border-radius: 2px;
  transform-origin: 2px 2px;
  position: absolute;
  background: var(--c, var(--color));
  transform: rotate(var(--r, 0deg));
  animation: var(--name, ${armLeg}) var(--duration) linear infinite;
`;
const Container = styled(motion.div)`
  --color: rgba(255, 255, 255, .3);
  --duration: .6s;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
`;
const Outer = styled.div`
  animation: ${outer} var(--duration) linear infinite;
`;
const Body = styled.div`
  background: var(--color);
  height: 15px;
  width: 8px;
  border-radius: 4px;
  transform-origin: 4px 11px;
  position: relative;
  transform: rotate(32deg);
  animation: ${body} var(--duration) linear infinite;

  &:before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 4px;
    bottom: 16px;
    left: 0;
    position: absolute;
    background: var(--color);
  }
`;
const Arm = styled.div`
  ${bodyPart}

  &:before {
    --l: 7px;
    --name: ${armBefore};
    ${bodyPart}
  }
`;
const Leg = styled.div`
  --w: 12px;
  --t: 11px;
  ${bodyPart}

  &:before {
    --t: 0;
    --l: 8px;
    ${bodyPart}
  }
`;
const ArmFront = styled(Arm)`
  --r: 24deg;
  --r-to: 164deg;

  &:before {
    --r: -48deg;
    --r-to: -36deg;
  }
`;
const ArmBehind = styled(Arm)`
  --r: 164deg;
  --r-to: 24deg;

  &:before {
    --r: -36deg;
    --r-to: -48deg;
  }
`;
const LegFront = styled(Leg)`
  --r: 10deg;
  --r-to: 108deg;

  &:before {
    --r: 18deg;
    --r-to: 76deg;
  }
`;
const LegBehind = styled(Leg)`
  --r: 108deg;
  --r-to: 10deg;
  --c: none;

  &:before {
    --c: var(--color);
    --r: 76deg;
    --r-to: 18deg;
  }

  &:after {
    content: '';
    top: 0;
    right: 0;
    height: 4px;
    width: 6px;
    clip-path: polygon(2px 0, 6px 0, 6px 4px, 0 4px);
    border-radius: 0 2px 2px 0;
    position: absolute;
    background: var(--color);
  }
`;

function Loading() {
  return (
    <React.Fragment>
      <Container initial="initial" exit="exit" variants={motionBox}>
        <Outer>
          <Body>
            <ArmFront />
            <ArmBehind/>
            <LegFront />
            <LegBehind />
          </Body>
        </Outer>
      </Container>
      <GlobalStyle />
    </React.Fragment>
  );
}

export default Loading;